// Human-readable names for subtitle language codes, mirroring the server's
// canonical list (api/pkg/translate/languages.go) plus English (the usual
// master language, which is not itself a translation target).
export const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  de: 'German',
  it: 'Italian',
  pt: 'Portuguese',
  nl: 'Dutch',
  pl: 'Polish',
  ru: 'Russian',
  ar: 'Arabic',
  hi: 'Hindi',
  zh: 'Mandarin Chinese',
  ja: 'Japanese',
  ko: 'Korean',
}

// languageName returns the human name for a code, falling back to the code.
export const languageName = (code?: string): string =>
  (code && LANGUAGE_NAMES[code]) || code || ''
